<template>
  <footer class="bg-accent text-cream-200">
    <!-- Main footer grid -->
    <div class="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-14">
      <div class="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6 sm:gap-8 lg:gap-10">

        <!-- Brand column -->
        <div class="lg:col-span-1">
          <img src="@/assets/logo-final.png" alt="HomeSweet Bites" class="h-14 w-auto mb-4 brightness-0 invert" />
          <p class="text-sm text-cream-200/70 leading-relaxed mb-5">
            Real home-cooked meals made with love, delivered fresh to your door every day.
          </p>
          <!-- Social links -->
          <div class="flex gap-3">
            <a
              v-for="social in socials"
              :key="social.name"
              :href="social.href"
              :aria-label="social.name"
              class="w-8 h-8 sm:w-9 sm:h-9 rounded-xl bg-cream-200/10 hover:bg-brand flex items-center justify-center transition-colors duration-150"
            >
              <span class="text-sm">{{ social.emoji }}</span>
            </a>
          </div>
        </div>

        <!-- Quick links -->
        <div>
          <h4 class="font-display font-bold text-white mb-4">Quick Links</h4>
          <ul class="flex flex-col gap-2.5 text-sm text-cream-200/70">
            <li v-for="link in quickLinks" :key="link.to">
              <router-link
                :to="link.to"
                class="hover:text-brand transition-colors duration-150"
              >{{ link.label }}</router-link>
            </li>
          </ul>
        </div>

        <!-- Working hours -->
        <div>
          <h4 class="font-display font-bold text-white mb-4">Opening Hours</h4>
          <ul class="flex flex-col gap-2.5 text-sm text-cream-200/70">
            <li v-for="hour in hours" :key="hour.day" class="flex justify-between gap-4">
              <span>{{ hour.day }}</span>
              <span class="text-cream-200/50">{{ hour.time }}</span>
            </li>
          </ul>
        </div>

        <!-- Contact -->
        <div>
          <h4 class="font-display font-bold text-white mb-4">Contact Us</h4>
          <ul class="flex flex-col gap-3 text-sm text-cream-200/70">
            <li class="flex items-start gap-2">
              <span class="mt-0.5">📍</span>
              <span>Kigali, Rwanda</span>
            </li>
            <li class="flex items-center gap-2">
              <span>📞</span>
              <a href="tel:+250788288199" class="hover:text-brand transition-colors">+250 788 288 199</a>
            </li>
            <li class="flex items-center gap-2">
              <span>✉️</span>
              <a href="mailto:hello@homesweetbites.rw" class="hover:text-brand transition-colors">hello@homesweetbites.rw</a>
            </li>
            <li class="flex items-center gap-2">
              <span>💬</span>
              <a href="#" class="hover:text-brand transition-colors">WhatsApp Order</a>
            </li>
          </ul>
        </div>

      </div>
    </div>

    <!-- Bottom bar -->
    <div class="border-t border-cream-200/10">
      <div class="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-4 flex flex-col sm:flex-row justify-between items-center gap-2 text-xs text-cream-200/40">
        <span>© {{ year }} HomeSweet Bites. All rights reserved.</span>
        <span class="flex items-center gap-2">
          Made with ❤️ in Rwanda
          <span class="opacity-30">·</span>
          <router-link
            to="/admin/login"
            class="opacity-30 hover:opacity-70 transition-opacity duration-200"
            title="Admin"
          >Admin</router-link>
        </span>
      </div>
    </div>
  </footer>
</template>

<script lang="ts">
import { defineComponent } from 'vue'

export default defineComponent({
  name: 'AppFooter',
  setup () {
    const year = new Date().getFullYear()

    const socials = [
      { name: 'Facebook', href: '#', emoji: 'f' },
      { name: 'Instagram', href: '#', emoji: '📸' },
      { name: 'WhatsApp', href: '#', emoji: '💬' }
    ]

    const quickLinks = [
      { to: '/', label: 'Home' },
      { to: '/menu', label: "Today's Menu" },
      { to: '/about', label: 'About Us' },
      { to: '/contact', label: 'Contact' }
    ]

    const hours = [
      { day: 'Mon – Fri', time: '10:00 – 21:00' },
      { day: 'Saturday', time: '10:00 – 22:00' },
      { day: 'Sunday', time: '11:00 – 20:00' }
    ]

    return { year, socials, quickLinks, hours }
  }
})
</script>
